@if (!is3dLayer) {
  <div class="toc-node-details-panel-section">
    <tm-layer-transparency [layer]="layerId"></tm-layer-transparency>
  </div>
}
@if (legendInfo$ | async; as legendInfo) {
  @if (legendInfo.isInScale) {
    <div
      class="toc-node-details-panel-section layer-legend">
      <h3 i18n="@@core.toc.legend">Legend</h3>
      <tm-legend-layer [legendInfo]="legendInfo" [showTitle]="false"></tm-legend-layer>
    </div>
  }
}
